import i18n from "~/i18n/i18n";

const t = (key: string, options?: Record<string, unknown>): string =>
	i18n.t(`csvImport.headers.${key}`, { ns: "common", ...options });

const csvHeaderLabels = {
	duplicates: (columns: string): string => t("duplicates", { columns }),
	missingRequired: (columns: string): string => t("missingRequired", { columns }),
	templateHint: (): string => t("templateHint"),
	unknownIgnored: (columns: string): string => t("unknownIgnored", { columns })
} as const;

export default csvHeaderLabels;
